import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-tiktok-black">
      {/* Header */}
      <div className="bg-tiktok-surface border-b border-white/10">
        <div className="container mx-auto px-4 md:px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-400 hover:text-tiktok-cyan transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-white mb-8">
            Impressum
          </h1>

          <div className="prose prose-invert max-w-none space-y-8">
            {/* Angaben gemäß § 5 TMG */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Angaben gemäß § 5 TMG</h2>
              <p className="text-gray-300">
                Erdem Trading GmbH<br />
                Melchiorstraße 14<br />
                68167 Mannheim<br />
                Deutschland
              </p>
            </section>

            {/* Vertreten durch */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Vertreten durch den Geschäftsführer:</h2>
              <p className="text-gray-300">Abdulaziz Erdem</p>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Kontakt:</h2>
              <p className="text-gray-300">
                Telefon: +49 179 8067007<br />
                E-Mail: info@pkwankauf24-7.de
              </p>
            </section>

            {/* Handelsregister */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Handelsregister:</h2>
              <p className="text-gray-300">
                Registergericht: Amtsgericht Mannheim<br />
                Registernummer: HRB 734832
              </p>
            </section>

            {/* Umsatzsteuer-ID */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Umsatzsteuer-ID:</h2>
              <p className="text-gray-300">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                <span className="text-white font-semibold">DE328119448</span>
              </p>
            </section>

            {/* Inhaltlich verantwortlich */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV:</h2>
              <p className="text-gray-300">
                Abdulaziz Erdem<br />
                Melchiorstraße 14<br />
                68167 Mannheim<br />
                Deutschland
              </p>
            </section>

            {/* Unternehmensgegenstand */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Unternehmensgegenstand:</h2>
              <p className="text-gray-300">Handel mit Kraftfahrzeugen</p>
            </section>

            {/* OS-Plattform */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Plattform der EU-Kommission zur Online-Streitbeilegung:</h2>
              <p className="text-gray-300">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-tiktok-cyan hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
            </section>

            {/* Verbraucherstreitbeilegung */}
            <section>
              <h2 className="text-xl font-bold text-white mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle:</h2>
              <p className="text-gray-300">
                Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Impressum;
